import { createAppSlice } from "../../app/createAppSlice"
import { createEntityAdapter } from '@reduxjs/toolkit'

//entity: { id: squential, resourceId: FOI, 
//          originalDatatype: "", originalPath: "", originalValue: ""{}[],
//          newDatatype: "", newPath: "", newValue: ""{}[],
//          changeComment: "", dateCreated: "dateTime" }
//key uses: creation of an Adaptation Report (record log of the changes) that can be used when adapting 
//          or updating a Resource or collection of Resources 

const resourceChangeReportAdapter = createEntityAdapter({
    sortComparer: (a, b) => {
        let adate = a?.dateCreated?.toString() || "";
        let bdate = b?.dateCreated?.toString() || "";
        if (bdate && adate && bdate !== adate) {
            return bdate.localeCompare(adate)
        } else if (b?.resourceId && a?.resourceId && b.resourceId !== a.resourceId) {
            return b.resourceId.localeCompare(a.resourceId)
        } else if (b?.originalPath && a?.originalPath && b.originalPath !== a.originalPath) {
            return b.originalPath.localeCompare(a.originalPath)
        } else {
            return 1 //0 would be preferred if order doesn't matter
        }
    }
})

const initialState = resourceChangeReportAdapter.getInitialState({
    status: 'idle',
    error: null
})

const resourceChangeReportSlice = createAppSlice({
    name: "resourceChangeReport",
    initialState,
    reducers: create => ({
        changeAdded: create.preparedReducer(
            (changeRecordBody) => {
                return {
                    payload: {
                        id: changeRecordBody.id,
                        resourceId: changeRecordBody.resourceId,
                        originalDatatype: changeRecordBody.originalDatatype,
                        originalPath: changeRecordBody.originalPath,
                        originalValue: changeRecordBody.originalValue,
                        newDatatype: changeRecordBody.newDatatype,
                        newPath: changeRecordBody.newPath,
                        newValue: changeRecordBody.newValue,
                        changeComment: changeRecordBody.changeComment,
                        dateCreated: changeRecordBody.dateCreated
                    }
                }
            },
            resourceChangeReportAdapter.addOne
        ),
        changeUpdated: create.reducer((state, action) => {
            const { id, resourceId, originalDatatype, originalPath, originalValue, newDatatype, newPath, newValue, changeComment, dateCreated } = action.payload;
            resourceChangeReportAdapter.updateOne(state,
                { id, changes: { resourceId, originalDatatype, originalPath, originalValue, newDatatype, newPath, newValue, changeComment, dateCreated } })
        }),
    }),
    selectors: {
        selectResourceChangeReportStatus: resourceChangeReport => resourceChangeReport.status,
        selectResourceChangeReportError: resourceChangeReport => resourceChangeReport.error
    },
})

export const { changeAdded, changeUpdated } = resourceChangeReportSlice.actions

export const { selectResourceChangeReportStatus, selectResourceChangeReportError } = resourceChangeReportSlice.selectors

export const {
    selectAll: selectAllResourceChanges,
    selectById: selectResourceChangeById,
} = resourceChangeReportAdapter.getSelectors(state => state.resourceChangeReport)

export default resourceChangeReportSlice